import FacebookTracker from 'lib/trackers/Facebook';
import GoogleAnalyticsTracker from 'lib/trackers/GoogleAnalytics';
import GoogleTagManager from 'lib/trackers/GoogleTagManager';

const isDev = process.env.NODE_ENV === 'development';

class Tracker {
  constructor() {
    this.fbTracker = new FacebookTracker(process.env.FACEBOOK_PIXEL_ID);
    this.gaTracker = new GoogleAnalyticsTracker(process.env.GOOGLE_ANALYTICS_ID);
    this.gtm = new GoogleTagManager(process.env.GTM_CONTAINER_ID);
  }
  setGTMDataLayer = (...args) => this.gtm.dataLayer(...args);
  trackFacebookEvent = (...args) => !isDev && this.fbTracker.trackEvent(...args);
  trackFacebookCustomEvent = (...args) => !isDev && this.fbTracker.trackCustomEvent(...args);
  trackFacebookPageView = (...args) => !isDev && this.fbTracker.trackPageView(...args);
  trackGoogleAnalyticsEvent = (...args) => {
    if (!isDev) {
      // this.gaTracker.trackEvent(...args);
      this.setGTMDataLayer({
        event: 'RippleEvent',
        customEvent: args[0],
        action: args[1],
      }, args[2]);
    }
  };

  trackGoogleTagManagerEvent = (event, action, data, isEcommerce = false) => {
    if (!isDev) {
      this.setGTMDataLayer({
        event: 'RippleEvent',
        customEvent: event,
        action,
      }, data, isEcommerce);
    }
  };
  trackGoogleAnalyticsException = (...args) => !isDev && this.gaTracker.trackException(...args);
  trackGoogleAnalyticsOutboundLink = (...args) => !isDev && this.gaTracker.trackOutboundLink(...args);
  trackGoogleAnalyticsPageView = (...args) => {
    if (!isDev) {
      // this.gaTracker.trackPageView(...args);
      this.setGTMDataLayer({
        pathName: args[0],
        pageTitle: args[1],
      }, args[2]);
    }
  };
  trackSnapPixelPageView = (pathname, description) => {
    if (!isDev && window?.snaptr) {
      window?.snaptr('track', 'PAGE_VIEW', { description, path: pathname });
    }
  };
  trackSnapPixelEvent = (event, data) => {
    if (!isDev && window?.snaptr) {
      window?.snaptr('track', event, data);
    }
  };
}

export default new Tracker();
